import { Entry } from 'contentful';
import { TypeKeyValueListFields } from '@/core/generated-types';

export type KeyValueMap = Record<string, string>;

interface KeyValueItem {
  key?: string;
  value?: string;
}

export const parseKeyValueList = (
  entry?: Entry<TypeKeyValueListFields>,
): KeyValueMap => {
  if (!entry?.fields?.keyValues) {
    return {};
  }

  return entry.fields.keyValues.reduce(
    (acc: KeyValueMap, item: KeyValueItem) => {
      if (item?.key && item?.value) {
        acc[item.key] = item.value;
      }
      return acc;
    },
    {} as KeyValueMap,
  );
};

export const getTranslation = (
  translations: KeyValueMap,
  key: string,
  fallback?: string,
): string => {
  return translations[key] ?? fallback ?? key;
};
